export const ActionTypes = {
  contactPhoneChange: 'CONTACT_PHONE_CHANGE',
  contactCancel: 'CONTACT_CANCEL',
  contactCompensation: 'CONTACT_COMPENSATION',
  contactBirthdayRegister: 'CONTACT_BIRTHDAY_REGISTER',
  clearState: 'CLEAR_STATE',
} as const
